<div class="appointment-form">
  <mat-radio-group [formControl]="carsControl">

    @if (loading) {
      <mat-radio-button labelPosition="before">
        <div class="flex my-2.5 items-center gap-2">
          <ngx-skeleton-loader appearance="line" animation="progress"></ngx-skeleton-loader>
          <div class="w-full text-xl text-left">
            <ngx-skeleton-loader appearance="line" animation="progress" [count]="3"></ngx-skeleton-loader>
          </div>
        </div>
      </mat-radio-button>
      <mat-divider class="my-5"></mat-divider>
    }

    <mat-divider class="my-5"></mat-divider>

    @for (v of vehicles; track v.vin) {
      <mat-radio-button
        attr.data-cy="add-new-appointment-vehicle-radio-{{ v.vin }}"
        value="{{ v.vin }}"
        (click)="vehicleSelected.emit(v)"
        (keydown.enter)="vehicleSelected.emit(v)"
        labelPosition="before"
        class="w-full"
      >
        @if (v) {
          <div class="flex my-2.5 items-center gap-4 w-full">
            @if (!loading) {
              <div [ngClass]="v.pictureType" class="hidden md:block shrink-0">
                @if (!v.brandPicture) {
                  <img
                    alt="ef logo"
                    class="w-[70px] h-auto m-auto rounded"
                    src="assets/ef-logo.svg"
                  />
                }
                @if (v.brandPicture) {
                  <img
                    alt="brand"
                    class="w-[70px] h-auto m-auto rounded"
                    [src]="v.brandPicture"
                  />
                }
              </div>
            }
            <div class="w-full text-xl text-left">
              @if (v.licensePlate && !loading) {
                <div class="license-plate-appointment">
                  {{ v.licensePlate }}
                </div>
              }
              @if (!loading) {
                <div class="text-mat-ef-revolution-secondary-500 text-base mt-2 mb-[2px] font-canelablack font-extrabold">
                  {{ v.brand ? v.brand : '' }} {{ v.model ? v.model : '' }}
                </div>
              }
              @if (!loading && v.dealer && country === 'de') {
                <div class="font-efSans-primary font-light text-sm">
                  {{ v.dealer.name ? v.dealer.name : '' }}
                </div>
              }
              @if (!loading && v.dealer && country === 'ch') {
                <div class="font-efSans-primary font-light text-sm">
                  {{ v.dealer.name ? v.dealer.name + (', ' + v.dealer.subname) || '' : '' }}
                </div>
              }
            </div>
          </div>
        }
      </mat-radio-button>
      <mat-divider class="my-5"></mat-divider>
    }

    @if (!loading && showOtherOption) {
      <div class="py-2.5">
        <mat-radio-button
          labelPosition="before"
          class="w-full"
          [checked]="isOtherSelected"
          (click)="onOtherClicked()"
          (keydown.enter)="onOtherClicked()"
        >
          <div>{{ translateShared('other') }}</div>
        </mat-radio-button>
        @if (isOtherSelected) {
          <div class="pt-2.5 h-auto grid auto-cols-auto">

            @if (country === 'de') {
              <mat-form-field appearance="fill" cdkScrollable>
                <mat-label>{{ translateShared('brand') }}</mat-label>
                <input
                  required
                  type="text"
                  matInput
                  [formControl]="makeControl"
                  [matAutocomplete]="auto"
                  [errorStateMatcher]="matcher"
                />
                <mat-autocomplete #auto="matAutocomplete">
                  @for (brand of filteredOptions | async; track brand.name) {
                    <mat-option
                      [value]="brand.name | titlecase"
                      (click)="brandSelected.emit(makeControl.value)"
                      (keydown.enter)="brandSelected.emit(makeControl.value)"
                    >
                      {{ brand.name | titlecase }}
                    </mat-option>
                  }
                </mat-autocomplete>
                @if (makeControl.errors) {
                  <mat-error>
                    <ng-container
                      *ngTemplateOutlet="errorTranslation; context: { data: makeControl }"
                    ></ng-container>
                  </mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="fill" cdkScrollable>
                <mat-label>{{ translateShared('model') }}</mat-label>
                <input
                  [readonly]="makeControl.errors ? true : false"
                  required
                  type="text"
                  matInput
                  [formControl]="modelControl"
                  [matAutocomplete]="modelAutocomplete"
                  [errorStateMatcher]="matcher"
                />
                <mat-autocomplete #modelAutocomplete="matAutocomplete">
                  @for (model of filteredOptionsModels | async; track model.name) {
                    <mat-option [value]="model.name | titlecase">
                      {{ model.name | titlecase }}
                    </mat-option>
                  }
                </mat-autocomplete>
                @if (modelControl.errors) {
                  <mat-error>
                    <ng-container
                      *ngTemplateOutlet="errorTranslation; context: { data: modelControl }"
                    ></ng-container>
                  </mat-error>
                }
              </mat-form-field>

              <div class="licence-plate">
                <mat-form-field appearance="fill" class="w-full">
                  <mat-label>
                    <T
                      str="Licence plate"
                      key="customerPortal.customer-portal.vehicle.details.registration-plate"
                      tags="customer-portal, 3.1"
                    ></T>
                  </mat-label>
                  <input
                    required
                    type="text"
                    matInput
                    [formControl]="licencePlateDE"
                    [errorStateMatcher]="matcher"
                  />
                  @if (licencePlateDE.errors) {
                    <mat-error>
                      <ng-container
                        *ngTemplateOutlet="errorTranslation; context: { data: licencePlateDE }"
                      ></ng-container>
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            }

            @if (country === 'ch') {
              <mat-form-field appearance="fill" cdkScrollable>
                <mat-label>{{ translateShared('brand') }}</mat-label>
                <input
                  required
                  type="text"
                  matInput
                  [formControl]="makeControl"
                  [matAutocomplete]="autoCH"
                  [errorStateMatcher]="matcher"
                />
                <mat-autocomplete #autoCH="matAutocomplete">
                  @for (brand of filteredOptions | async; track brand.name) {
                    <mat-option
                      [value]="brand.name | titlecase"
                      (click)="brandSelected.emit(makeControl.value)"
                      (keydown.enter)="brandSelected.emit(makeControl.value)"
                    >
                      {{ brand.name | titlecase }}
                    </mat-option>
                  }
                </mat-autocomplete>
                @if (makeControl.errors) {
                  <mat-error>
                    <ng-container
                      *ngTemplateOutlet="errorTranslation; context: { data: makeControl }"
                    ></ng-container>
                  </mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="fill" cdkScrollable>
                <mat-label>{{ translateShared('model') }}</mat-label>
                <input
                  [readonly]="makeControl.errors ? true : false"
                  required
                  type="text"
                  matInput
                  [formControl]="modelControl"
                  [matAutocomplete]="modelAutocompleteCH"
                  [errorStateMatcher]="matcher"
                />
                <mat-autocomplete #modelAutocompleteCH="matAutocomplete">
                  @for (model of filteredOptionsModels | async; track model.name) {
                    <mat-option [value]="model.name | titlecase">
                      {{ model.name | titlecase }}
                    </mat-option>
                  }
                </mat-autocomplete>
                @if (modelControl.errors) {
                  <mat-error>
                    <ng-container
                      *ngTemplateOutlet="errorTranslation; context: { data: modelControl }"
                    ></ng-container>
                  </mat-error>
                }
              </mat-form-field>

              <div class="grid grid-cols-4 gap-0 md:gap-5">
                <mat-form-field
                  class="hidden md:inline-block col-span-1 custom-select"
                  appearance="fill"
                >
                  <mat-label>
                    <T
                      str="Canton"
                      key="customerPortal.customer-portal.vehicle.details.registration-plate-canton"
                      tags="customer-portal, 3.1"
                    ></T>
                  </mat-label>
                  <mat-select
                    [formControl]="licencePlateCanton"
                    required
                    [errorStateMatcher]="matcher"
                  >
                    @for (k of cantons; track k.id) {
                      <mat-option [value]="k.id">{{ k.id }}</mat-option>
                    }
                  </mat-select>
                  @if (licencePlateCanton.errors) {
                    <mat-error>
                      <ng-container
                        *ngTemplateOutlet="errorCHTranslation; context: { data: licencePlateCanton }"
                      ></ng-container>
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="inline-block col-span-4 md:hidden">
                  <mat-label>
                    <T
                      str="Canton"
                      key="customerPortal.customer-portal.vehicle.details.registration-plate-canton"
                      tags="customer-portal, 3.1"
                    ></T>
                  </mat-label>
                  <select
                    required
                    matNativeControl
                    [formControl]="licencePlateCanton"
                    [errorStateMatcher]="matcher"
                  >
                    @for (k of cantons; track k.id) {
                      <option [value]="k.id">{{ k.id }}</option>
                    }
                  </select>
                </mat-form-field>

                <mat-form-field appearance="fill" class="col-span-4 md:col-span-3">
                  <mat-label>
                    <T
                      str="Licence plate"
                      key="customerPortal.customer-portal.vehicle.details.registration-plate"
                      tags="customer-portal, 3.1"
                    ></T>
                  </mat-label>
                  <input
                    required
                    type="text"
                    matInput
                    [formControl]="licencePlateCH"
                    [errorStateMatcher]="matcher"
                  />
                  @if (licencePlateCH.errors) {
                    <mat-error>
                      <ng-container
                        *ngTemplateOutlet="
                          errorCHTranslation;
                          context: {
                            data: licencePlateCH,
                            maxlength: licencePlateCH.errors?.maxlength?.requiredLength
                          }
                        "
                      ></ng-container>
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            }

          </div>
        }
        <mat-divider class="mt-7 hidden"></mat-divider>
      </div>
    }

  </mat-radio-group>
</div>

<ng-template #errorTranslation let-data="data">
  {{
    transifexService.getErrorTranslation(
      data,
      'customerPortal.customer-portal.appointment.error.',
      {
        errKey: {
          pattern: 'only-numbers-letters-allowed',
          maxlength: 'maximum-length-exceeded'
        }
      }
    )
  }}
</ng-template>

<ng-template #errorCHTranslation let-data="data" let-maxlength="maxlength">
  {{
    transifexService.getErrorTranslation(
      data,
      'customerPortal.customer-portal.appointment.ch.error.',
      {
        num: maxlength,
        errKey: {
          pattern: 'only-numbers-allowed',
          maxlength: 'max-length-characters'
        }
      }
    )
  }}
</ng-template>
